import { render, staticRenderFns } from "./SpendByProject.vue?vue&type=template&id=160020e7&scoped=true&"
import script from "./SpendByProject.vue?vue&type=script&lang=js&"
export * from "./SpendByProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160020e7",
  null
  
)

export default component.exports